// extracted by mini-css-extract-plugin
module.exports = {"navigationButton":"style_navigationButton__2NDkN","wrapperChip":"style_wrapperChip__XbjJt","bold":"style_bold__RSrHS"};